import React from "react";
import { COMPANY } from "../data/content";

export default function TickerCard({ testId = "ticker-card" }) {
  return (
    <div
      className="bg-[#1A1512] border border-[#3A2E22] p-6 md:p-8"
      data-testid={testId}
    >
      <div className="flex items-center gap-2 mb-5">
        <span className="h-1.5 w-1.5 rounded-full bg-[#F26A1B] animate-pulse" />
        <span className="text-[11px] font-mono uppercase tracking-[0.22em] text-[#A79E93]">
          Public equity · U.S. capital markets
        </span>
      </div>
      <div className="grid grid-cols-2 gap-x-8 gap-y-6">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-[#8A8075] mb-2">Symbol</div>
          <div className="text-white font-display text-3xl md:text-4xl font-semibold">
            {COMPANY.ticker}
          </div>
        </div>
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-[#8A8075] mb-2">Market</div>
          <div className="text-white font-display text-3xl md:text-4xl font-semibold">
            {COMPANY.market}
          </div>
        </div>
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-[#8A8075] mb-2">SEC CIK</div>
          <div className="text-white font-mono text-lg md:text-xl">{COMPANY.cik}</div>
        </div>
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-[#8A8075] mb-2">Fiscal Year End</div>
          <div className="text-white font-mono text-lg md:text-xl">{COMPANY.fiscalYearEnd}</div>
        </div>
      </div>
    </div>
  );
}
